import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlashcards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFlashcards"><Path d="M3 8.04528L12.9452 7L14.412 20.9553L4.46676 22.0005L3 8.04528Z" fill="currentColor"/><Path d="M21.1123 3.04492L19.6455 17.001L15.457 16.5605L14.2803 5.35156L10.7764 5.71875L11.167 2L21.1123 3.04492Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlashcards;
